import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiAutoscrollOnDragDirective } from './fi-autoscroll-on-drag.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [FiAutoscrollOnDragDirective],
    exports: [FiAutoscrollOnDragDirective],
})
export class FiAutoscrollOnDragModule {}
